import React from 'react';
/* eslint-disable */
export const IconStat = () => (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 41.5C13 39.567 14.567 38 16.5 38C18.433 38 20 39.567 20 41.5V78H13V41.5Z" fill="url(#paint0_linear_3848_4399)"/>
    <path d="M35 33.5C35 31.567 36.567 30 38.5 30C40.433 30 42 31.567 42 33.5V78H35V33.5Z" fill="url(#paint1_linear_3848_4399)"/>
    <path d="M57 41.5C57 39.567 58.567 38 60.5 38C62.433 38 64 39.567 64 41.5V78H57V41.5Z" fill="url(#paint2_linear_3848_4399)"/>
    <path d="M9 51C9 49.8954 9.89637 49 11.0021 49H18.1711C32.961 49 47.4619 53.0913 60.0665 60.8204L82.0418 74.2955C83.7633 75.3511 83.0143 78 80.9944 78H11.0021C9.89637 78 9 77.1046 9 76V51Z" fill="#E3F4FF"/>
    <path d="M24 25.5C24 23.567 25.567 22 27.5 22C29.433 22 31 23.567 31 25.5V78H24V25.5Z" fill="url(#paint3_linear_3848_4399)"/>
    <path d="M46 17.5C46 15.567 47.567 14 49.5 14C51.433 14 53 15.567 53 17.5V78H46V17.5Z" fill="url(#paint4_linear_3848_4399)"/>
    <path d="M68 25.5C68 23.567 69.567 22 71.5 22C73.433 22 75 23.567 75 25.5V78H68V25.5Z" fill="url(#paint5_linear_3848_4399)"/>
    <defs>
    <linearGradient id="paint0_linear_3848_4399" x1="16.2044" y1="78" x2="15.8643" y2="29.998" gradientUnits="userSpaceOnUse">
    <stop stopColor="#7ECCF8"/>
    <stop offset="1" stopColor="#0087CD"/>
    </linearGradient>
    <linearGradient id="paint1_linear_3848_4399" x1="16.2044" y1="78" x2="15.8643" y2="29.998" gradientUnits="userSpaceOnUse">
    <stop stopColor="#7ECCF8"/>
    <stop offset="1" stopColor="#0087CD"/>
    </linearGradient>
    <linearGradient id="paint2_linear_3848_4399" x1="16.2044" y1="78" x2="15.8643" y2="29.998" gradientUnits="userSpaceOnUse">
    <stop stopColor="#7ECCF8"/>
    <stop offset="1" stopColor="#0087CD"/>
    </linearGradient>
    <linearGradient id="paint3_linear_3848_4399" x1="49.5" y1="78" x2="49.5" y2="14" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C1E4FA"/>
    <stop offset="1" stopColor="#9FD0EE"/>
    </linearGradient>
    <linearGradient id="paint4_linear_3848_4399" x1="49.5" y1="78" x2="49.5" y2="14" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C1E4FA"/>
    <stop offset="1" stopColor="#9FD0EE"/>
    </linearGradient>
    <linearGradient id="paint5_linear_3848_4399" x1="49.5" y1="78" x2="49.5" y2="14" gradientUnits="userSpaceOnUse">
    <stop stopColor="#C1E4FA"/>
    <stop offset="1" stopColor="#9FD0EE"/>
    </linearGradient>
    </defs>
    </svg>
);

